<template>
  <transition name="transition">
    <div
      v-if="showMsg"
      class="msg-bar"
      @click="onMsgBarClick"
      v-bind:class="{
        'msg-bar--show': showMsg,
        'msg-bar--hide': !showMsg,
        'msg-bar--success': msgType == 'success',
        'msg-bar--negative': msgType == 'error',
        'msg-bar--info': msgType == 'info',
        'msg-bar--warning': msgType == 'warning',
      }"
    >
      <p v-for="(message, key) in messages" :key="key" v-html="message"></p>
      <button class="msg-bar__btn" @click.stop="showMsg = false">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.15 27.15">
          <path
            d="M16.26,13.57,26.59,3.24A1.9,1.9,0,0,0,23.9.56L13.57,10.89,3.24.56A1.88,1.88,0,0,0,.56.56a1.88,1.88,0,0,0,0,2.68L10.89,13.57.56,23.9a1.9,1.9,0,1,0,2.68,2.69L13.57,16.26,23.9,26.59a1.93,1.93,0,0,0,1.35.56,1.91,1.91,0,0,0,1.34-3.25Z"
          />
        </svg>
      </button>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      showMsg: false,
      messages: null,
      msgType: "",
    };
  },
  watch: {
    showMsg(showmsg) {
      if (showmsg) {
        document.body.classList.add("msg-bar--shown");
      } else {
        document.body.classList.remove("msg-bar--shown");
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (typeof window.MAIN_APP !== "undefined") {
        window.MAIN_APP.$on("showmsg", (data) => {
          this.msgType = data.type ? data.type : "success";

          if (data.messages) {
            this.messages =
              typeof data.messages == "string"
                ? [data.messages]
                : data.messages;
          }

          this.showMsg = true;
        });

        window.MAIN_APP.$on("closemsg", (data) => {
          this.showMsg = false;
        });
      }
    });
  },
  beforeDestroy() {
    if (typeof window.MAIN_APP !== "undefined") {
      window.MAIN_APP.$off("showmsg");
      window.MAIN_APP.$off("closemsg");
    }

    document.body.classList.remove("msg-bar--shown");
  },
  methods: {
    onMsgBarClick() {
      if (typeof window.MAIN_APP !== "undefined") {
        window.MAIN_APP.$emit("msgclick");
      }
    },
  },
};
</script>